export default "__VITE_ASSET__CAc6bs3Y__"